(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kabar-blog-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kabar-journal')) {
    customElements.define('kabar-journal', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.kj-track');
        this.cards = [...this.querySelectorAll('.kj-card')];
        this.prev = this.querySelector('[data-kj-prev]');
        this.next = this.querySelector('[data-kj-next]');
        this.play = this.querySelector('[data-kj-play]');
        this.counter = this.querySelector('[data-kj-counter]');
        this.abort = new AbortController();
        const opts = {signal: this.abort.signal};
        this.prev.addEventListener('click', () => this.move(-1), opts);
        this.next.addEventListener('click', () => this.move(1), opts);
        this.play.addEventListener('click', () => this.toggle(), opts);
        this.track.addEventListener('scroll', () => this.update(), opts);
        this.addEventListener('focusin', () => this.stop(), opts);
        this.addEventListener('pointerenter', () => this.stop(), opts);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, opts);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const step = this.cards[0]?.getBoundingClientRect().width + 24;
        this.track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        const left = this.track.scrollLeft;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = left < 4;
        this.next.disabled = left >= max - 4;
        const step = this.cards[0]?.getBoundingClientRect().width + 24;
        const first = Math.round(left / step) + 1;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + 24) / step));
        this.counter.textContent = first + '–' + Math.min(this.cards.length, first + visible - 1) + ' / ' + this.cards.length;
      }
      toggle() {
        if (this.timer) { this.stop(); return; }
        this.play.textContent = this.play.dataset.pause;
        this.play.setAttribute('aria-pressed', 'true');
        this.timer = setInterval(() => {
          if (this.next.disabled) this.track.scrollTo({left: 0, behavior: 'instant'});
          else this.move(1);
        }, 6000);
      }
      stop() {
        clearInterval(this.timer);
        this.timer = null;
        this.play.textContent = this.play.dataset.play;
        this.play.setAttribute('aria-pressed', 'false');
      }
      disconnectedCallback() {
        this.stop();
        this.abort.abort();
        this.resize.disconnect();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
